import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'firebase/auth';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../shared/services/api.service';

import { UserService } from 'src/app/shared/services/user-services/user.service';
import { Editor, Toolbar } from 'ngx-editor';





@Component({
  selector: 'app-signup-form',
  templateUrl: './signup-form.component.html',
  styleUrls: ['./signup-form.component.css'],
})
export class SignupFormComponent implements OnInit {
  authForm!: FormGroup;
  showPassword = true;
  user: User | null = null;
  userAForm!: FormGroup;
  userBForm!: FormGroup;
  userCForm!: FormGroup;
  editor!: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  states: any;
  cities: any;
  selectedFile: File | null = null;
  imagePreview: string | null = null;
  orgName: any
  constructor(
    private formBuilder: FormBuilder,
    private readonly userAuthService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private toastrMsgService: ToastrService,
    private readonly apiService: ApiService,
  ) { }

  ngOnInit() {
    this.initForm();
    this.checkLogIn();
    this.userAForm = this.formBuilder.group({
      org_name: ["", Validators.required],
      org_type: ["", Validators.required],
      registration_number: ["", [Validators.required,Validators.pattern(
      /^([LU]\d{5}[A-Z]{2}\d{4}(PLC|PTC|OPC|NPL|FTC|FLC|ULL|GAP|TLC|SSD|SGC|FSC|NIC|NDC)\d{6}|[A-Z]{3}\d{4})$/
    )]],
      gst_number: ["", [Validators.required, Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$')]],
      pan_number: ["", [Validators.required, Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$')]],
      city: ["", Validators.required],
      state: ["", Validators.required],
      postal_code: ["", Validators.required],
      country: ["", Validators.required],
      domain: ["", Validators.required],
      org_logo: [null],
      address_line_1: ["", Validators.required],
      address_line_2: ["", Validators.required],

    });
    this.userBForm = this.formBuilder.group({
      primary_contact_name: ["", Validators.required],
      primary_contact_email: ["", [Validators.required, Validators.email]],
      primary_contact_phone: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
    });

//    this.userAForm.setValue({
//   org_name: "SigmaT Infra Pvt Ltd",
//   org_type: "private_limited",
//   registration_number: "REG123456",
//   gst_number: "27AAECS1234F1Z5",
//   pan_number: "AAECS1234F",
//   city: "Mumbai",
//   state: "Maharashtra",
//   postal_code: "400001",
//   country: "India",
//   domain: "['Consultancy','Education']",
//   org_logo: "dummy_logo.png", // This can be a File object or string, depending on usage
//   address_line_1: "123, SigmaT Building",
//   address_line_2: "Andheri East",
// });
//  this.onCountryChange() ;
//  this.onStateChange()
// this.userBForm.setValue({
//   primary_contact_name: "Nilesh Patel",
//   primary_contact_email: "nilesh.patel@sigmatinfra.com",
//   primary_contact_phone: "9876543210"
// });
  }
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.uploadImage(this.selectedFile)
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.selectedFile);

    }
  }

  uploadImage(file: any) {
    // const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.apiService.uploadContractDocs(file, 'org')?.subscribe({
        next: (res: any) => {
          this.userAForm.patchValue({
            org_logo: res?.org,
          });

          this.userAForm.get('org_logo')?.updateValueAndValidity();
          this.toastrMsgService.success('Organization logo uploaded successfully');
        },
        error: err => console.error('Organization logo upload failed', err)
      });
    }
  }
  nameFach() {
    this.orgName = this.userAForm.value.org_name
  }
  onCountryChange() {

    const country = this.userAForm.value.country;
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.states = res;
        this.cities = [];
        this.userAForm.patchValue({ state: '', city: '' });
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });
  }

  onStateChange() {
    const state = this.userAForm.value.state;
    // const selectedState = this.states.find(s => s.name === state);
    // this.cities = selectedState ? selectedState.cities : [];
    // this.userAForm.patchValue({ city: '' });
    this.apiService.getdistricts(state).subscribe({
      next: (res) => {
        this.cities = res;
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });
  }
  loginWithGoogle() {
    this.userAuthService.loginWithGoogle().then(result => {
      this.user = result.user;
    }).catch(console.error);
  }

  loginWithFacebook() {
    this.userAuthService.loginWithFacebook().then(result => {
      this.user = result.user;
    }).catch(console.error);
  }

  logout() {
    this.userAuthService.logoutA().then(() => {
      this.user = null;
    });
  }

  initForm() {
    this.authForm = this.formBuilder.group({
      email: ['', Validators.required],

    });
  }

  checkLogIn() {
    if (this.userAuthService.getUserDetailsFromSession()) {
      this.router.navigate(['home/dashboard'])
    }
  }


  get formControls() {
    return this.authForm?.controls;
  }

  signUp() {

    const types = this.userAForm.value.domain
    const result = types.join(',');
    var addUser = {
      "org_name": this.userAForm.value.org_name,
      "org_type": this.userAForm.value.org_type,
      "registration_number": this.userAForm.value.registration_number,
      "gst_number": this.userAForm.value.gst_number,
      "city": this.userAForm.value.city,
      "state": this.userAForm.value.state,
      "postal_code": this.userAForm.value.postal_code,
      "pan_number": this.userAForm.value.pan_number,
      "country": this.userAForm.value.country,
      "domain": result,
      "primary_contact_name": this.userBForm.value.primary_contact_name,
      "primary_contact_phone": this.userBForm.value.primary_contact_phone,
      "primary_contact_email": this.userBForm.value.primary_contact_email,
      "org_logo": this.userAForm.value.org_logo,
      "address_line_2": this.userAForm.value.address_line_2,
      "address_line_1": this.userAForm.value.address_line_1,

    }

    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    if (returnUrl) {
      try {
        sessionStorage.setItem('bidding_returnUrl', decodeURIComponent(returnUrl));
      } catch (e) {
        sessionStorage.setItem('bidding_returnUrl', returnUrl);
      }
    }
    this.userAuthService.signupEmail(addUser).subscribe({
      next: (res) => {
        localStorage.setItem("email", this.userBForm.value.primary_contact_email);
        localStorage.setItem('user', JSON.stringify(res));
        this.router.navigate(['onboarding/verify-email']);
      },
      error: (err) => {
        this.toastrMsgService.error(err?.error?.message);
        this.authForm.setErrors({ incorrectCredentials: true }); // Set custom error for incorrect credentials
      },
      complete: () => console.log('Observable complete'),
    });
  }

  goToSignin(): void {
    this.router.navigate(['/']);
  }
  

}
